import { WorkspaceApiKeysRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/api-keys')({
  component: WorkspaceApiKeysRoute,
});
